import { cx } from '@linaria/core';
import { useRef, useState, useEffect } from 'react';
import { useToggleState, useChangeEffect } from '@utils/react';
import { wrapper, modifiers, flipWrapper, cardSideWrapper, questionSide, answerSide } from './_card.style.js';
import { CardSide } from './atom.card-side.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useMarkCardAsSeenMutation } from '../../state/mutation.mark-card-as-seen.js';
import { useUpdateLocationMutation } from '../../state/mutation.update-location.js';

function Card(props) {
  const wrapperRef = useRef(null);
  const imageRef = useRef(null);
  const markAsSeen = useMarkCardAsSeenMutation(props.entryKey);
  const updateLocation = useUpdateLocationMutation(props.entryKey);
  const [hasFocus, setHasFocus] = useState(false);
  const [isFlipped, setFlipped] = useToggleState(false);
  const handleFlip = () => {
    if (!props.focused) {
      props.pagination.goTo(props.index);
      updateLocation(props.index);
    }
    setFlipped.toggle();
    setTimeout(() => {
      markAsSeen(props.index);
    });
  };
  const handleAudioButtonClicked = () => {
    if (!props.focused) {
      props.pagination.goTo(props.index);
      updateLocation(props.index);
    }
  };
  useChangeEffect(() => {
    setFlipped.disable();
  }, [props.entryKey]);

  // allow user to scroll up/down using arrows on his keyboard
  useEffect(() => {
    if (!hasFocus) {
      return;
    }
    const onKeyDown = evt => {
      switch (evt.key) {
        case "ArrowDown":
          wrapperRef.current?.querySelector(`.${cardSideWrapper}.active`)?.scrollBy({
            top: 100,
            behavior: "smooth"
          });
          evt.preventDefault();
          break;
        case "ArrowUp":
          wrapperRef.current?.querySelector(`.${cardSideWrapper}.active`)?.scrollBy({
            top: -100,
            behavior: "smooth"
          });
          evt.preventDefault();
          break;
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [hasFocus]);
  return /*#__PURE__*/jsx("section", {
    className: cx(wrapper, isFlipped && modifiers.flipped.className),
    children: /*#__PURE__*/jsxs("div", {
      ref: wrapperRef,
      className: flipWrapper
      // focus will be handled interactively by the slider component, add
      // tabIndex to ensure that the card is reachable.
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      ,
      tabIndex: 0,
      "aria-roledescription": "Vendekort",
      onKeyDown: event => {
        if (event.key === "Enter" || event.key === " ") {
          handleFlip();
          event.preventDefault();
        }
      },
      onFocus: () => {
        if (!props.focused) {
          setTimeout(() => {
            props.pagination.goTo(props.index);
            updateLocation(props.index);
          });
        }
        setHasFocus(true);
      },
      onBlur: () => setHasFocus(false),
      onClick: evt => {
        if (evt.button === 0 && !props.focused) {
          props.pagination.goTo(props.index);
          updateLocation(props.index);
        }
      },
      children: [/*#__PURE__*/jsx("div", {
        className: cx(cardSideWrapper, questionSide, !isFlipped && "active"),
        children: /*#__PURE__*/jsx(CardSide, {
          tooltipTargetRef: imageRef,
          content: props.card.question,
          isActive: !isFlipped && props.focused,
          isVisible: !isFlipped,
          onAudioButtonClicked: handleAudioButtonClicked,
          onFlipButtonClicked: handleFlip,
          fallbackLabel: props.globalLabels.question,
          cardHasFocus: hasFocus
        })
      }), /*#__PURE__*/jsx("div", {
        className: cx(cardSideWrapper, answerSide, isFlipped && "active"),
        children: /*#__PURE__*/jsx(CardSide, {
          tooltipTargetRef: imageRef,
          content: props.card.answer,
          isActive: isFlipped && props.focused,
          isVisible: isFlipped,
          onAudioButtonClicked: handleAudioButtonClicked,
          onFlipButtonClicked: handleFlip,
          fallbackLabel: props.globalLabels.answer,
          cardHasFocus: hasFocus
        })
      })]
    })
  });
}

export { Card };
//# sourceMappingURL=_card.js.map
